// Method for formatting HTTP body for the multipart/form-data specification
// Mostly taken from Fermata.js
// https://github.com/natevw/fermata/blob/5d9732a33d776ce925013a265935facd1626cc88/fermata.js#L315-L343

const isObject = (obj: any) => {
  const type = typeof obj;
  return (type === 'function' || type === 'object') && !!obj;
};

// For use in multipart requests
const flattenAndStringify = (data: Record<string, any>) => {
  const result: Record<string, any> = {};

  const step = (obj: Record<string, any>, prevKey?: string) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      const newKey = prevKey ? `${prevKey}[${key}]` : key;

      if (isObject(value)) {
        if (!Buffer.isBuffer(value) && !value.hasOwnProperty('data')) {
          // Non-buffer non-file Objects are recursively flattened
          return step(value, newKey);
        } else {
          // Buffers and file objects are stored without modification
          result[newKey] = value;
        }
      } else {
        // Primitives are converted to strings
        result[newKey] = String(value);
      }
    });
  };

  step(data);

  return result;
};

export const encodeMultipartRequest = (
  data: Record<string, any>,
): {contentTypeHeader: string; data: Buffer} => {
  const segno = (
    Math.round(Math.random() * 1e16) + Math.round(Math.random() * 1e16)
  ).toString();
  const contentTypeHeader = `multipart/form-data; boundary=${segno}`;
  let buffer = Buffer.alloc(0);

  function push(l: any) {
    const prevBuffer = buffer;
    const newBuffer = l instanceof Buffer ? l : Buffer.from(l);
    buffer = Buffer.alloc(prevBuffer.length + newBuffer.length + 2);
    prevBuffer.copy(buffer);
    newBuffer.copy(buffer, prevBuffer.length);
    buffer.write('\r\n', buffer.length - 2);
  }

  function q(s: string) {
    return `"${s.replace(/"|"/g, '%22').replace(/\r\n|\r|\n/g, ' ')}"`;
  }

  const flattenedData = flattenAndStringify(data);

  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (const k in flattenedData) {
    const v = flattenedData[k];
    push(`--${segno}`);
    if (v.hasOwnProperty('data')) {
      push(
        `Content-Disposition: form-data; name=${q(k)}; filename=${q(
          v.name || 'blob',
        )}`,
      );
      push(`Content-Type: ${v.type || 'application/octet-stream'}`);
      push('');
      push(v.data);
    } else {
      push(`Content-Disposition: form-data; name=${q(k)}`);
      push('');
      push(v);
    }
  }
  push(`--${segno}--`);

  return {contentTypeHeader, data: buffer};
};
